import React, { useEffect, useState } from 'react';

import "../../../css/components/OrderInfo/StatusWindow/StatusWindow.css";

import { formatTaiwanDate, Message } from '../../../utils';

import { getDeliverRecordByDeliver } from '../../../service/api/DeliveryRecord/apiDeliveryRecord';

const StatusWindow = ({ order, deliveryRecord, onClose }) => {

    const [deliveryRecordOrder, setDeliveryRecordOrder] = useState([]);
    const [record, setRecord] = useState({});

    const isToday = record.deliveryDate?.slice(0, 10) == new Date().toISOString().slice(0, 10);

    useEffect(() => {
        getDeliverRecordByDeliver({ type: !deliveryRecord ? 'order' : 'recordOrder', id: !deliveryRecord ? order?.id : deliveryRecord.id })
            .then(response => {
                if (response?.status === 200 && response?.data.status === 1) {
                    setDeliveryRecordOrder(response.data.result.Order);
                    setRecord(response.data.result.DeliveryRecord);
                } else {
                    Message(response.data.message, 'warning');
                }
            });
    }, []);

    const orderList = deliveryRecordOrder?.map(o => ({
        id: o.id,
        status: o.isShipped
    })) ?? [];

    const firstPendingIndex = orderList.findIndex(o => !o.status);

    return (
        // <div className="status-window-backdrop">
        <div className="status-window">

            <div className="status-header">
                <h3>訂單配送進度</h3>
                <button className="close-btn" onClick={onClose}>✕</button>
            </div>

            <h4>紀錄ID:{deliveryRecord?.id ?? record.id}</h4>
            <div className="status-timeline scroll-area">
                {orderList.map((oid, index) => {
                    const isFirstPending = index === firstPendingIndex;
                    const isCurrentView = oid.id === order?.id;

                    return (
                        <div className="timeline-item" key={oid.id}>
                            {index !== 0 && <div className="timeline-line"></div>}

                            {/* Dot */}
                            <div className={`timeline-dot ${isFirstPending || isCurrentView ? "active" : ""}`}></div>

                            {/* Order ID */}
                            <div className="timeline-order">{oid.id}</div>

                            {/* Status container */}
                            <div className="timeline-status">
                                {isCurrentView && (
                                    <div className="status-tag view">🔍 查看中…</div>
                                )}
                                <div className={`status-tag ${!oid.status ? isToday ? isFirstPending ? 'active' : '' : '' : 'isShipped'}`}>
                                    {oid.status ? '✅ 已完成' : (isToday ? isFirstPending ? '🚚 正在運送中' : '等待配送' : '等待配送')}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
        // </div>
    );
};

export { StatusWindow };
